export enum ProjectTimelinesActionType {
    CREATE_PROJECT_TIMELINE = 'CREATE_PROJECT_TIMELINE',
    GET_ALL_PROJECT_TIMELINE = 'GET_ALL_PROJECT_TIMELINE',
    UPDATE_PROJECT_TIMELINE = 'UPDATE_PROJECT_TIMELINE',
    UPDATE_PROJECT_TIMELINE_INTAKES = 'UPDATE_PROJECT_TIMELINE_INTAKES',
    GET_TIMELINES_BY_USERID = 'GET_TIMELINES_BY_USERID',
    DELETE_PROJECT_TIMELINE = 'DELETE_PROJECT_TIMELINE',
}
